module.exports = __webpack_public_path__ + "media/scholarship_winners/amanda-p-c414c7ea.png";